export type SameSite = 'lax' | 'strict' | 'none';

export type CookieOptions = {
  path?: string;
  expires?: Date | string;
  maxAge?: number;
  secure?: boolean;
  sameSite?: SameSite;
  domain?: string;
};

export const isBrowser = () => typeof document !== 'undefined';

export function getCookie(name: string): string | undefined {
  if (!isBrowser()) return undefined;
  const pattern = `; ${document.cookie}`;
  const parts = pattern.split(`; ${encodeURIComponent(name)}=`);
  if (parts.length === 2) {
    const value = parts.pop()!.split(';')[0];
    return value ? decodeURIComponent(value) : undefined;
  }
  return undefined;
}

export function setCookie(name: string, value: string, opts: CookieOptions = {}) {
  if (!isBrowser()) return;

  const secureDefault = window.location?.protocol === 'https:';
  const sameSite = opts.sameSite ?? 'lax';
  const secure = opts.secure ?? secureDefault;
  const path = opts.path ?? '/';

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += '; Secure';

  if (opts.maxAge !== undefined) cookie += `; Max-Age=${Math.floor(opts.maxAge)}`;
  else if (opts.expires) {
    const exp = typeof opts.expires === 'string' ? opts.expires : opts.expires.toUTCString();
    cookie += `; Expires=${exp}`;
  }

  if (opts.domain) cookie += `; Domain=${opts.domain}`;

  document.cookie = cookie;
}

export function deleteCookie(name: string, opts: CookieOptions = {}) {
  setCookie(name, '', { ...opts, expires: new Date(0), maxAge: 0 });
}
